// extracted by mini-css-extract-plugin
export var icon = "_b6-3";
export var subtitle = "_b6-2";
export var title = "_b6-1";
export var value = "_b6-0";